import { useSelector } from "react-redux";

import { LayoutContextProvider } from "_metronic";

import AutoTestIds from "app/common/AutoTestIds";
import { useLastLocation } from "app/common/hooks/useLastLocation";
import MfaNoticeDialog from "app/common/mfa/MfaNoticeDialog";
import RecommendedMfaSetupDialog from "app/common/mfa/RecommendedMfaSetupDialog";
import Notifier from "app/common/notifier";
import TaskStatusViewer from "app/common/tasks-status-viewer";

/**
 * Wrapper component that provides context and global components
 * This runs inside the router, so hooks work here
 */
export default function AppWrapper({ children }) {
  useLastLocation();

  const menuConfig = useSelector((store) => store.builder.menuConfig);
  const taskViewerAnchor = useSelector((store) => store.builder.taskViewerAnchor);
  const isAuthenticated = useSelector((store) => Boolean(store.auth.user));

  return (
    <LayoutContextProvider menuConfig={menuConfig}>
      <AutoTestIds />
      {children}
      <Notifier />
      <TaskStatusViewer anchor={taskViewerAnchor} />
      {isAuthenticated && <RecommendedMfaSetupDialog />}
      {isAuthenticated && <MfaNoticeDialog authenticated={isAuthenticated} />}
    </LayoutContextProvider>
  );
}
